import { FC } from 'react';
import { Link } from 'react-router-dom';
import { LogoST } from '../../../logo-st';

interface LogoTextProps {
    to: string;
    title: string;
    description: string;
    mantleColor?: string;
}

export const LogoText: FC<LogoTextProps> = ({ to, title, description, mantleColor }) => (
    <Link to={to} className="logo-text">
        <div className="logo-text-wrapper">
            <LogoST width={35} height={32} mantleFill={mantleColor} />
        </div>
        <div className="logo-text-info">
            <span className="logo-text-title">{title}</span>
            <span className="logo-text-description t-truncate">{description}</span>
        </div>
    </Link>
);
